<template>

	<PageHeader :title="category.name || TR.drinks" icon="fas fa-wine-bottle" />

	<div class="container py-3 py-sm-3">

		<div class="row bg-site rounded-top">
			<div class="col-12 col-sm-2 ">
				<div class="p-3 px-4 text-light">
					<h5 class="text-center fw-bold pt-1 pb-1 text-light">{{ TR.filters }}</h5>
				</div>
			</div>
			<div class="col-12 col-sm-10 offset-sm-21">

					<!-- v-if="products.length" -->
				<Pagination
					ref="pagination_ref"
					:pages_count="pages_count"
					:rows_count="rows_count"
					route_name="products_by_page"
					:route_obj="route_obj"
					class="text-light"
				>
					<template #clear>
						<button v-if="showClearFilter" class="btn btn-outline-light my-31 rounded-1 me-3 fs-71" @click="onClearFilter" :title="TR.clear"><i class="fas fa-trash"></i></button>
					</template>

					<template #content>
						<div class="w-100 p-1 mx-4 d-flex flex-row align-items-center justify-content-center">
							<div class="fw-bold me-3">{{ TR.sort_by }}:</div>

							<Dropdown v-model="selectedSortField" :options="sortFields" optionValue="value" optionLabel="label" style="width: 12rem;" @onChange="onSortingChanged">
								<template #selected="slotProps">
									<span>
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
									</span>
								</template>
								<template #option="slotProps">
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
								</template>
							</Dropdown>
							<Dropdown v-model="selectedSortOrder" :options="sortOrders" optionValue="value" optionLabel="label" @onChange="onSortingChanged">
								<template #selected="slotProps">
									<span>
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
									</span>
								</template>
								<template #option="slotProps">
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
								</template>
							</Dropdown>
						</div>
					</template>

				</Pagination>

			</div>
		</div>

		<div class="row">
			<div class="filter-menu bg-site text-white px-2 mb-3 mb-sm-0">

				<div v-if="filters.length" class="filter-menu-container">

					<!-- <h5 class="text-center fw-bold pb-3 bg-light1 text-dark1">{{ TR.categories }}</h5> -->



					<!-- <nav>
						<ul>
							<FilterCategoryItem :data="categories" :parent_id="0" :category_id="category_id" />
						</ul>
					</nav> -->

					<div class="accordion accordion-flush">


						<div v-if="category?.children?.length > 0" class="accordion-item">
							<h2 class="accordion-header">
								<button class="accordion-button fw-normal collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-0" aria-expanded="false" aria-controls="flush-0">
									{{ TR.type }}
								</button>
							</h2>
							<div id="flush-0" class="accordion-collapse collapse show">
								<div class="accordion-body bg-site">
									<div v-for="(gfitem, gfindex) in category.children" :key="gfindex" class="p-1">
										<router-link class="bg-site" :to="{'name': 'products_by_category', params: { category_id: gfitem.id }}">
											{{ gfitem.name }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="accordion accordion-flush mb-3" id="mainAccordion">
							<!-- <nav class="mb-3">
								<ul>
									<li v-for="(item, index) in category.children" :key="index">
										<router-link class="bg-site" :to="{'name': 'products_by_category', params: { category_id: item.id }}">
											{{ item.name }}
										</router-link>
									</li>
								</ul>
							</nav>
							<h5 v-if="category?.children?.length > 0" class="text-center fw-bold pt-4 pb-3 bg-light1 text-dark1">{{ TR.filters }}</h5> -->


							<!-- <h2 class="accordion-header">
								<a class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="`#flush-${item.id}`" aria-expanded="false" :aria-controls="`flush-${item.id}`">
									{{ item.translate[0].name }}
								</button>
							</h2>

							<div :id="`flush-${item.id}`" class="accordion-collapse collapse show">
								<div class="accordion-body">
									<div v-for="(gfitem, gfindex) in item.group_filters" :key="gfindex">
										<label class="form-check">
											<input v-model="selectedFilters[gfitem.id]" class="form-check-input" type="checkbox" name="filterCheck" value="">
											<span class="form-check-label">
												{{ gfitem.translate[0].name }}
											</span>
										</label>
									</div>
								</div>
							</div> -->

						<div class="accordion-item" v-for="(item, index) in filters" :key="index">
							<h2 class="accordion-header">
								<button class="accordion-button fw-normal" :class="index == 0 ? '' : 'collapsed'" type="button" data-bs-toggle="collapse" :data-bs-target="`#flush-${item.id}`" aria-expanded="false" :aria-controls="`flush-${item.id}`">
									{{ item.translate[0].name }}
								</button>
							</h2>

							<div :id="`flush-${item.id}`" class="accordion-collapse collapse" :class="index == 0 ? 'show' : ''" data-bs-parent="#mainAccordion">
								<div class="accordion-body bg-site">
									<div v-for="(gfitem, gfindex) in item.group_filters" :key="gfindex" class="p-1">
										<label class="form-check">
											<!-- <input class="form-check-input" type="checkbox" name="exampleRadio" value=""> -->
											<input v-model="selectedFilters[gfitem.id]" class="form-check-input" type="checkbox" name="filterCheck" value="">
											<span class="form-check-label">
												{{ gfitem.translate[0].name }}
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>

						<!-- <div class="accordion-item">
							<h2 class="accordion-header">
								<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-4" aria-expanded="false" aria-controls="flush-4">
									{{ TR.color }}
								</button>
							</h2>
							<div id="flush-4" class="accordion-collapse collapse show">
								<div class="accordion-body">
									<div class="card-body color-filter">
										<input type="checkbox" class="form-check-input rounded-circle bg-danger">
										<input type="checkbox" class="form-check-input rounded-circle bg-secondary">
										<input type="checkbox" class="form-check-input rounded-circle bg-primary">
										<input type="checkbox" class="form-check-input rounded-circle bg-warning">
										<input type="checkbox" class="form-check-input rounded-circle bg-success">
										<input type="checkbox" class="form-check-input rounded-circle bg-info">
										<input type="checkbox" class="form-check-input rounded-circle bg-light">
									</div>
								</div>
							</div>
						</div> -->

					</div>

					<!-- <article class="range">
						<label for="customRange3" class="form-label">Deyeri:   {{ rangedata }}</label>
						<input v-model="rangedata" type="range" class="form-range" min="0" max="100" step="1" id="customRange3">
					</article> -->

					<article class="card-group-item px-2 pt-3">
						<h6 class="py-2">{{ TR.production_year }}</h6>
						<!-- <header class="card-header">
						</header> -->
						<div class="filter-content">
							<div class="card-body">
								<div class="row">
									<div class="form-group col">
										<label>Min</label>
										<!-- <input v-model="year_min" min="0" type="number" class="form-control" id="inputEmail4" placeholder="0"> -->
										<DatePicker v-model="year_min" view="year" dateFormat="yy" />
									</div>
									<div class="form-group col text-end">
										<label>Max</label>
										<!-- <input v-model="year_max" min="0" type="number" class="form-control" placeholder="1,0000"> -->
										<DatePicker v-model="year_max" view="year" dateFormat="yy" />
									</div>
								</div>
							</div>
						</div>
					</article>

					<article class="card-group-item px-2 pt-3">
						<h6 class="py-2">{{ TR.price }}</h6>
						<!-- <header class="card-header">
						</header> -->
						<div class="filter-content">
							<div class="card-body">
								<div class="row">
									<div class="form-group col">
										<label>Min</label>
										<input v-model="price_min" min="0" type="number" class="form-control" id="inputEmail4" placeholder="0">
									</div>
									<div class="form-group col text-end">
										<label>Max</label>
										<input v-model="price_max" min="0" type="number" class="form-control" placeholder="1,0000">
									</div>
								</div>
							</div>
						</div>
					</article>

					<!-- <div class="row">
						<div class="col text-center">
							<button class="btn btn-danger my-3 rounded-1 me-3 fs-7" @click="onClearFilter"><i class="fas fa-trash me-2"></i>{{ TR.clear }}</button>
						</div>
					</div> -->
					<button class="btn btn-light w-100 my-3 rounded-1 fs-7" @click="onShowFilter"><i class="far fa-check-square me-2"></i>{{ TR.show }}</button>

				</div>
			</div>

			<div class="col p-0 ps-sm-2 pe-sm-0 m-0">


				<nav v-if="category?.drink_rule?.length > 0 || category?.description?.length > 0" class="d-flex justify-content-center align-items-center border-bottom py-2">
					<!-- <ul style="list-style: none;" class="d-flex flex-row gap-51 px-0 my-2 cursor-pointer"> -->
						<!-- <li v-if="category?.drink_rule?.length > 0" @click="showModal(TR.drink_rule, category?.drink_rule)"> -->
							<a class="bg-success bg-opacity-10 rounded cursor-pointer px-3 me-3 py-2" data-bs-toggle="modal" data-bs-target="#categoryInfoModal" @click="showModal(TR.drink_rule, category?.drink_rule)">
							<!-- <a class="btn bg-light text-dark" style="width: 3.5rem;" @click="showModal(TR.drink_rule, category?.drink_rule)" :title="TR.drink_rule"> -->
							<!-- <a class="btn bg-light text-dark d-flex justify-content-center align-items-center" style="width: 3.5rem;" @click="showModal(TR.drink_rule, category?.drink_rule)" :title="TR.drink_rule"> -->
									<i class="far fa-question-circle fs-4 me-2"></i>
									{{ TR.drink_rule }}
							</a>
						<!-- </li>
						<li v-if="category?.description?.length > 0" @click="showModal(TR.about, category?.description)"> -->
							<a class="bg-success bg-opacity-10 rounded cursor-pointer px-3 py-2" data-bs-toggle="modal" data-bs-target="#categoryInfoModal" @click="showModal(TR.about, category?.description)">
							<!-- <a class="btn bg-light text-dark" style="width: 3.5rem;" @click="showModal(TR.about, category?.description)" :title="TR.about"> -->
							<!-- <a class="btn bg-light text-dark d-flex justify-content-center align-items-center" style="width: 3.5rem;" @click="showModal(TR.about, category?.description)" :title="TR.about"> -->
								<i class="fas fa-info-circle fs-4 me-2"></i>
								{{ TR.about }}
							</a>
						<!-- </li> -->
					<!-- </ul> -->
				</nav>


				<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 card-group g-0 g-sm-2 p-0 py-3">
					<template v-if="products.length">
						<div class="mb-3" v-for="(item, index) in products" :key="index">
							<Product :data="item" :lang="TR" />
						</div>
					</template>
					<div v-else-if="!loadingProducts && products.length == 0" class="col w-100 text-center text-danger fw-bold fs-4 my-5">{{ TR.noresult }} !</div>
					<div v-else-if="loadingProducts" class="col w-100 text-center text-danger fw-bold fs-4">
						<div class="d-flex justify-content-center py-5">
							<div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
								<span class="visually-hidden">{{ TR.loading }}</span>
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>

		<div class="row bg-site rounded-bottom">
			<div class="col-12 col-sm-10 offset-sm-2">

					<!-- v-if="products.length" -->
				<Pagination
					ref="pagination_ref"
					:pages_count="pages_count"
					:rows_count="rows_count"
					route_name="products_by_page"
					:route_obj="route_obj"
					class="text-light"
				>
					<template #clear>
						<button v-if="showClearFilter" class="btn btn-outline-light my-31 rounded-1 me-3 fs-71" @click="onClearFilter"><i class="fas fa-trash"></i></button>
					</template>

					<template #content>
						<div class="w-100 p-1 mx-4 d-flex flex-row align-items-center justify-content-center">
							<div class="fw-bold me-3">{{ TR.sort_by }}:</div>

							<Dropdown v-model="selectedSortField" :options="sortFields" optionValue="value" optionLabel="label" style="width: 12rem;" @onChange="onSortingChanged">
								<template #selected="slotProps">
									<span>
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
									</span>
								</template>
								<template #option="slotProps">
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
								</template>
							</Dropdown>
							<Dropdown v-model="selectedSortOrder" :options="sortOrders" optionValue="value" optionLabel="label" @onChange="onSortingChanged">
								<template #selected="slotProps">
									<span>
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
									</span>
								</template>
								<template #option="slotProps">
										<i v-if="slotProps.item.icon" style="width: 1rem;" class="me-2" :class="slotProps.item.icon"></i>
										{{ slotProps.item.label }}
								</template>
							</Dropdown>
						</div>
					</template>

				</Pagination>

			</div>
		</div>

		<Modal ref="modalref" id="categoryInfoModal" :data="modaldata" />

	</div>

</template>


<script>
import { onBeforeMount, watchEffect, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useStore } from '@/store';

import DatePicker from 'primevue/datepicker';

import Product from '@/components/card/Product.vue';
import PageHeader from '@/components/header/PageHeader';
// import FilterCategoryItem from '@/components/navbar/FilterCategoryItem';
import Pagination from '@/components/Pagination';
import Dropdown from '@/components/field/Dropdown';

import Modal from '@/components/modal/Scrollable';

import { ajax } from '@/_common';

export default {
	name: 'ProductsP',
	title: 'drinks',
	components:{
		Product,
		PageHeader,
		// FilterCategoryItem,
		Pagination,
		Dropdown,
		DatePicker,
		Modal,
	},
	props:{
		data: {
			type: Object,
			default: () => {}
		},
	},
	setup() {
		const store = useStore();
		const route = useRoute();
		const router = useRouter();

		const TR = ref({});
		const rangedata = ref(10);
		const filters = ref([]);
		// const categories = ref([]);
		const products = ref([]);
		const rows_count = ref(0);
		const pages_count = ref(1);
		const sortFields = ref([]);
		const sortOrders = ref([]);
		const selectedSortField = ref("name");
		const selectedSortOrder = ref(1);
		const selectedFilters = ref({});
		const pagination_ref = ref();
		const category = ref({});
		const category_id = ref(0);
		const rowperpage = ref(20);
		const year_min = ref();
		const year_max = ref();
		const price_min = ref(0);
		const price_max = ref(0);
		const searchText = ref('');
		const route_obj = ref({});
		const loadingProducts = ref(true);
		const prd_res = ref({});

		const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
		const selected_filters = route.params && route.params.filters ? route.params.filters.split(',') : [];

		category_id.value = route.params && route.params.category_id ? parseInt(route.params.category_id) : 0;
		rowperpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : 20;
		year_min.value = route.params && route.params.year_min ? new Date(parseInt(route.params.year_min), 0, 1) : new Date(new Date().getFullYear()+1, 0, 1);
		year_max.value = route.params && route.params.year_max ? new Date(parseInt(route.params.year_max), 0, 1) : new Date(new Date().getFullYear()+1, 0, 1);
		price_min.value = route.params && route.params.price_min ? parseInt(route.params.price_min) : 0;
		price_max.value = route.params && route.params.price_max ? parseInt(route.params.price_max) : 0;
		searchText.value = route.query && route.params.search_text ? route.params.search_text : '';

		watchEffect(() => {
			TR.value = store.getTranslation();

			sortFields.value = [
				// {value: '', label: TR.value.select, class: 'text-secondary'},
				{value: 'name', label: TR.value.by_name, icon: 'fas fa-signature'},
				{value: 'price', label: TR.value.by_price, icon: 'fas fa-dollar-sign'},
				{value: 'create_date', label: TR.value.by_date, icon: 'far fa-calendar'},
			];

			sortOrders.value = [
				{value: '1', label: TR.value.sort_low_high, icon: 'fas fa-sort-amount-down-alt'},
				{value: '-1', label: TR.value.sort_high_low, icon: 'fas fa-sort-amount-down'}
			];
			if( selected_filters.length > 0 ){
				selected_filters.map(f => {
					if( f != '0' ){
						selectedFilters.value[f] = true;
					}
				});
			}

			if( prd_res.value.data !== undefined ){
				products.value = prd_res.value.data;
				rows_count.value = prd_res.value.total_records;
				pages_count.value = Math.ceil(rows_count.value/rowperpage.value);
			}
		});

		onBeforeMount(async () => {
			if( category_id.value > 0 ){
				await ajax({
					url: store.getCategoryById(category_id.value),
					success: (e) => {
						category.value = e.data;
					}
				});
			}

			await ajax({
				url: store.getFilters(),
				success: (e) => {
					filters.value = e.data;
				}
			});

			selectedSortField.value = route.params.sortfield || "name";
			selectedSortOrder.value = parseInt(route.params.sortorder || 1);

			await getFilteredData();
			await getProducts();

		});

		const getFilteredData = async () => {
		// const getFilteredData = async (data = null) => {
			// let prm = {};

			// if (data != null) {
			// 	prm = Object.assign(prm, data);
			// }

			let passYear = parseInt(new Date().getFullYear()+1);

			route_obj.value = {
				// params: {
					page: page,
					perpage: rowperpage.value,
					category_id: parseInt(category_id.value) || 0,
					year_min: parseInt(year_min.value.getFullYear()) < passYear ? parseInt(year_min.value.getFullYear()) : passYear,
					year_max: parseInt(year_max.value.getFullYear()) < passYear ? parseInt(year_max.value.getFullYear()) : passYear,
					quarters: parseInt(route.params.quarters) || 0,
					price_min: parseInt(price_min.value) || 0,
					price_max: parseInt(price_max.value) || 0,
					sortfield: selectedSortField.value,
					sortorder: selectedSortOrder.value,
					filters: Object.keys(selectedFilters.value).filter((k) => selectedFilters.value[k] == true).join(',') || '0',
					search_text: searchText.value || '0',
				// },
				// query: {
				// 	search_text: searchText.value || '',
				// }
			};
		};

		const getProducts = async () => {
			loadingProducts.value = true;

			await ajax({
				// .get(store.getters.getSoldierFilterLink(), { params: route_obj.value })
				// url: store.getProductsByCategory(category_id.value),
				url: store.getProductsPaging(route_obj.value),
				// method: 'get',
				// data: selectedFilters.value,
				success: (e) => {
					prd_res.value = e.data;
					// if( products.value.length > 0 ){
					// 	loadingProducts.value = false;
					// }
					// pages_count.value = Math.ceil(e.data.data.length/perpage);
				},
			});
			loadingProducts.value = false;
		};

		const onSortingChanged = async () => {
			await getFilteredData();
			pagination_ref.value.changePage(1);
			// route_obj.value = Object.assign(
			// 	route_obj.value,
			// 	{
			// 		page: 1,
			// 		perpage: rowperpage.value,
			// 	},
			// );
			// await getProducts();
		};

		const onShowFilter = async () => {
			await getFilteredData();
			// if( products.value.length > 0 )
			// pagination_ref.value.changePage();
			router.push({
				name: 'products_by_page',
				params: Object.assign(
					route_obj.value,
					{
						page: 1,
						perpage: rowperpage.value,
					},
				),
				// query: {
				// 	search_text: searchText.value,
				// },
			});
			// route_obj.value = Object.assign(
			// 	route_obj.value,
			// 	{
			// 		page: 1,
			// 		perpage: rowperpage.value,
			// 	},
			// );
			// await getProducts();
		};

		const showClearFilter = computed(() => {
			// console.log(Object.keys(selectedFilters).length && selectedFilters.constructor !== Object);
			// console.log(year_min.value < new Date(new Date().getFullYear()+1, 0, 1) || year_max.value < new Date(new Date().getFullYear()+1, 0, 1));
			// console.log(price_min.value > 0 || price_max.value > 0);
			return selected_filters.length && selected_filters[0] != '0' ? true : (year_min.value < new Date(new Date().getFullYear()+1, 0, 1) || year_max.value < new Date(new Date().getFullYear()+1, 0, 1) ? true : (price_min.value > 0 || price_max.value > 0 ? true : false));
		});

		const onClearFilter = async () => {
			selectedFilters.value = {};
			// category_id.value = 0;
			rowperpage.value = 20;
			year_min.value = new Date(new Date().getFullYear()+1, 0, 1);
			year_max.value = new Date(new Date().getFullYear()+1, 0, 1);
			price_min.value = 0;
			price_max.value = 0;
			searchText.value = '';
			selectedSortField.value = 'name';
			selectedSortOrder.value = 1;

			await getFilteredData();
			router.push({
				name: 'products_by_page',
				params: Object.assign(
					route_obj.value,
					{
						page: 1,
						perpage: rowperpage.value,
					},
				),
			});
		};

		const modalref = ref();
		const modaldata = ref();
		const showModal = (title, data) => {
			modaldata.value = {
				'title': '',
				'content': '',
				'btn': '',
			};
			modaldata.value = {
				'title': title,
				'content': data.replace(/\n|\r/mgi, '<br />'),
				'btn': TR.value.close,
			};
			// modalref.value.show = true;
		};

		return {
			TR,
			pagination_ref,
			products,
			rangedata,
			filters,
			// categories,
			category,
			category_id,
			route_obj,
			pages_count,
			rows_count,
			sortFields,
			sortOrders,
			selectedSortField,
			selectedSortOrder,
			selectedFilters,
			getFilteredData,
			onSortingChanged,
			onShowFilter,
			showClearFilter,
			onClearFilter,
			year_min,
			year_max,
			price_min,
			price_max,
			loadingProducts,
			showModal,
			modalref,
			modaldata,
		};
	},
}
</script>


<style lang="scss">
.filter-menu{
	width: 300px;
}
.card-group-item{
	margin-bottom: 1rem;
}
.color-filter>.form-check-input{
	padding: 12px;
	margin-right: 5px;
}
.color-filter>.form-check-input:checked{
	background-image: unset !important;
}
.color-filter>.form-check-input:checked::before{
	position: relative;
	font-family: "Font Awesome 5 Free";
	font-weight: 900;
	content: '\f00c';
	color: #fff;
	left: -7px;
	top: -10px;
}
.color-filter>.form-check-input.bg-light:checked::before{
	color: #000;
}
label.form-check, .color-filter>.form-check-input{
	cursor: pointer;
}

.p-datepicker-panel{
	font-size: .9rem;
	width: 220px !important;
	position: relative;
}

@media(max-width: 576px){
	.filter-menu{
		width: 100%;
	}
}


.filter-menu-container {
	nav {
		position: relative;
	}
	nav ul {
		list-style-type: none;
		margin: 0;
		padding-left: 0;
		border: 0;
	}
	a {
		display: block;
		padding: 10px 5px;
		color: #fff;
		text-decoration: none;
		// -webkit-transition: 0.2s linear;
		// -moz-transition: 0.2s linear;
		// -ms-transition: 0.2s linear;
		// -o-transition: 0.2s linear;
		// transition: 0.2s linear;
		// box-sizing: border-box;
	}
	ul ul {
		background-color: rgba(0, 0, 0, 0.2);
	}
	ul ul li:first-child {
		border-top: 0;
	}
	ul ul li:last-child {
		border-bottom: 0;
	}
	li:first-child {
		border-top: .05rem solid rgba(155, 154, 154, 0.3);
	}
	li {
		border-bottom: .05rem solid rgba(155, 154, 154, 0.3);
	}
	ul li a {
		border-left: 4px solid transparent;
		// padding: 10px 10px;
	}
	ul ul a, ul ul .form-check-label{
		// font-size: .85rem;
		font-size: calc(var(--bs-body-font-size) * 0.9);
	}
	nav ul li a:hover, nav ul li ul li a:hover {
		background-color: rgba(155, 154, 154, 0.3);
		border-left: 4px solid #fff; //rgb(var(--site-primary-color-rgb));
	}

	nav ul li.li-submenu > a {
		background-color: rgba(155, 154, 154, 0.3);
		border-left: 4px solid #fff; //rgb(var(--site-primary-color-rgb));
	}

	ul ul {
		display: block;
		// padding: 10px 5px;
		margin: 0;
		padding-left: 10px;
	}

	a.submenu::after {
		background: unset;
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f0d7";
		text-align: center;
		vertical-align: middle;
		// width: var(--bs-accordion-btn-icon-width);
		// height: var(--bs-accordion-btn-icon-width);
		transition: var(--bs-accordion-btn-icon-transition);
		float: inline-end;
	}
	ul li a:not(:is(.collapsed))::after{
		background: unset;
		transform: rotate(-180deg);
	}
	.filter-menu-body{
		max-height: 220px;
		overflow: hidden;
		overflow-y: auto;
	}
	.filter-menu-body .filter-menu-body{
		max-height: 100%;
	}


	/** --------------------------------------------------------- */

	.accordion{
		--bs-accordion-active-color: var(--bs-white);
		/* --bs-accordion-active-bg: var(--bs-primary-bg-subtle); */
		--bs-accordion-btn-focus-border-color: unset;
		/* --bs-accordion-btn-bg: var(--bs-accordion-bg); */
		--bs-accordion-color: var(--bs-white);
		--bs-accordion-bg: transparent;

		/* --bs-accordion-active-color: var(--bs-primary-text-emphasis);
		--bs-accordion-active-bg: var(--bs-primary-bg-subtle);
		--bs-accordion-btn-focus-border-color: #86b7fe;
		--bs-accordion-btn-bg: var(--bs-accordion-bg);
		--bs-accordion-color: var(--bs-body-color);
		--bs-accordion-bg: var(--bs-body-bg); */

		/* border-bottom: 0.05rem solid rgba(155, 154, 154, 0.3); */
	}
	.accordion-item {
		/* border: 0.05rem solid rgba(155, 154, 154, 0.3); */
		border: 0px;
	}
	// .accordion-item .accordion-item .accordion-button {
	// 	background-color: rgba(175, 182, 182, 0.1);
	// }
	.accordion-header {
		border-top: 0.05rem solid rgba(155, 154, 154, 0.3);
		padding: 4px 8px;
		// background-color: rgba(175, 182, 182, 0.2);
	}
	.accordion-header > .accordion-button:not(.collapsed) {
		border-bottom: 0.05rem solid rgba(155, 154, 154, 0.3);
	}
	/* , .accordion-item:nth-last-child(-n + 1) .accordion-body */
	#mainAccordion .accordion-item:nth-last-child(-n + 1) .accordion-button, #mainAccordion .accordion-item:nth-last-child(-n + 1) .accordion-body {
		border-bottom: 0.05rem solid rgba(155, 154, 154, 0.3);
	}
	.accordion .accordion .accordion-item:nth-last-child(-n + 1) .accordion-body{
		border-bottom: 0;
	}
	/* .accordion-item .accordion-item .accordion-button::before {
		content: '-';
		margin-right: 4px;
	} */
	.accordion-body{
		padding: 4px 2px 10px 6px;
		// height: 100px;
		max-height: 150px;
		overflow: hidden;
		overflow-y: auto;
	}
	.main-accordion .accordion-body{
		max-height: 100%;
	}
	.accordion-body .accordion-body{
		padding: 4px 2px 4px 8px;
		/* background-color: rgba(175, 182, 182, 0.2); */
		max-height: 100%;
	}
	.accordion-body a {
		display: block;
		padding: 4px;
	}
	.accordion-body a:hover {
		background-color: rgba(175, 182, 182, 0.1);
	}
	.accordion-button{
		color: var(--bs-light);
		/* background-color: rgba(175, 182, 182, 0.4); */
		padding: 8px 4px;
		font-weight: 600;
	}
	.accordion-button::after{
		background: unset;
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f0d7";
		text-align: center;
		vertical-align: middle;
	}
	.accordion-button:focus {
		border-color: unset;
		box-shadow: unset;
	}
	.accordion-button:not(.collapsed) {
		/* background-color: rgba(175, 182, 182, 0.4); */
		background-color: unset;
		box-shadow: unset;
	}
	.accordion-button:not(.collapsed)::after{
		background: unset;
		transform: rotate(-180deg);
	}

}


</style>
